import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import ContextPagination from 'rebook/apps/base/components/ContextPagination';
import BookList from 'rebook/apps/books/components/BookList';
import CatalogDescription from 'rebook/apps/catalog/components/CatalogDescription';
import AdaptiveImage from 'rebook/apps/utils/components/AdaptiveImage';
import BooksetAuthor from 'rebook/apps/base/components/BooksetAuthor';
import EmptyBookCard from 'rebook/apps/books/components/EmptyBookCard';
import * as BookshelfDetailActions from 'rebook/apps/catalog/actions/BookshelfDetailActions';
import * as NotificationActions from 'rebook/apps/users/actions/NotificationActions';
import pluralize from 'rebook/apps/utils/text/pluralize';
import BreadCrumbs from 'rebook/apps/base/components/BreadCrumbs';
import headerStyles from 'rebook/apps/catalog/components/CatalogHeader/style.scss';
import booksetStyles from 'rebook/apps/catalog/views/BooksetDetailView/style.scss';
import CatalogFilter from 'rebook/apps/catalog/components/Filters/CatalogFilter';
import EmptyFilterResult from 'rebook/apps/base/components/EmptyFilterResult';
import DropDownMenu from 'rebook/apps/base/components/DropDownMenu';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';
import { URLS } from 'rebook/apps/base/constants';


import styles from './style.scss';


const MAXIMUM_NUMBER_CHARACHTERS = 50;

class BookshelfDetailView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      openDeleteDialog: false,
    };
  }
  componentDidMount() {
    const { match, location } = this.props;
    // componentDidMount is never called by server side
    // so we fetch data for client here
    this.props.BookshelfDetailActions.fetchInitialData(match, location);
  }

  componentWillUnmount() {
    this.props.BookshelfDetailActions.resetData();
  }

  changePage(pageNumber) {
    window.scrollTo(0, 0);
    this.props.BookshelfDetailActions.fetchBookList({ pageNumber });
  }

  filterBySubscriptionType(subscriptionId) {
    this.props.BookshelfDetailActions.fetchBookList({ subscriptionId });
  }

  changeBookType(bookType) {
    this.props.BookshelfDetailActions.fetchBookList({ bookType });
  }

  resetFilters() {
    this.props.BookshelfDetailActions.fetchBookList({
      subscriptionId: null,
      bookType: null,
    });
  }

  handleCloseDeleteDialog() {
    this.setState({ openDeleteDialog: false });
  }

  handleOpenDeleteDialog() {
    this.setState({ openDeleteDialog: true });
  }

  cropString(name, maxLength) {
    if (!name) {
      return '';
    }
    return name.length > maxLength
      ? name.substring(0, MAXIMUM_NUMBER_CHARACHTERS) + '...'
      : name;
  }

  deleteConfirmDialog() {
    const { bookshelf } = this.props.bookshelfDetail;
    return (
      <ModalDialog fullSizeForSmall extraClassname={styles.modalDialogContainer}
        onClose={() => { this.handleCloseDeleteDialog();}} dialog={
          {
            id: '1',
            extraClassName: classNames(styles.modalDialogContent, 'jest-delete-confirm-dialog'),
            emojiIcon: '',
            title: '',
            content:
              <div className={styles.modalDialog}>
                <span className={styles.modalDialogImage}>😢</span>
                <span className={styles.modalDialogHeader}>Удалить полку</span>
                <span className={styles.modalDialogHeaderTitle}>
                  Не волнуйтесь, при удалении полки те книги,&nbsp;
                  которые вы добавили на неё, не удалятся,&nbsp;
                  а останутся в Моих книгах.
                </span>
                <div className={styles.modalDialogButtons}>
                  <div className={classNames(styles.deleteDialogButton, 'jest-delete-bookshelf-button')}
                    onClick={() => this.deleteBookshelf(bookshelf.id)}>
                    Удалить
                  </div>
                  <div className={classNames(styles.cancelDialogButton, 'jest-close-dialog-button')}
                    onClick={() => this.handleCloseDeleteDialog()}>
                    Не удалять
                  </div>
                </div>
              </div>,
          }
        } />
    );
  }

  deleteBookshelf(bookshelfId) {
    const { history, bookshelfDetail } = this.props;
    const { bookshelf } = bookshelfDetail;

    this.props.BookshelfDetailActions.deleteBookshelf(bookshelfId)
      .then((success) => {
        ga('send', 'event', {
          eventCategory: 'Shelves',
          eventAction: 'DeleteShelf',
          eventLabel: 'MyShelves',
        });
        document.querySelector('body').classList.remove('isNotScrollable');
        if (success) {
          this.handleCloseDeleteDialog();
          this.props.NotificationActions.pop(`🗑 Полка “${bookshelf.name}” удалена`);
          history.push(`/profile/${this.props.match.params.userId}/bookshelves/`);
        }
        else {
          this.handleCloseDeleteDialog();
          this.props.NotificationActions.pop(`Произошла ошибка`, 'error');
        }
      });
  }

  deleteBookFromBookshelf(bookshelfId, book) {
    const { bookshelfDetail } = this.props;
    const { bookshelf } = bookshelfDetail;
    const bookId = get(book, 'id', '');
    const { bookType, subscriptionId } = bookshelfDetail;
    this.props.BookshelfDetailActions.deleteBookFromBookshelf({ bookshelfId, bookId })
      .then((success) => {
        document.querySelector('body').classList.remove('isNotScrollable');
        if (success) {
          this.props.BookshelfDetailActions.fetchBookList({
            subscriptionId,
            bookType,
          });
          let bookshelfName = get(bookshelf, 'name', '');
          bookshelfName = bookshelfName.substring(0, 100);
          this.props.NotificationActions.pop(`✂️ Книга удалена c полки “${bookshelfName}”`);
        }
        else {
          this.handleCloseDeleteDialog();
          this.props.NotificationActions.pop(`Произошла ошибка`, 'error');
        }
      });
  }

  getBookList(params) {
    const { books, bookshelfId, user, bookshelfIsOwnedByUser } = params;
    if (user && bookshelfIsOwnedByUser) {
      return <BookList books={books} handleDelete={(book) => this.deleteBookFromBookshelf(bookshelfId, book)} />;
    }
    else {
      return <BookList books={books} />;
    }
  }

  render() {
    const { openDeleteDialog } = this.state;
    const { user, bookshelfDetail } = this.props;
    const { bookshelf, books, pageNumber, lastPageNumber, bookType, subscriptionId } = bookshelfDetail;

    const isPublicBookshelf = get(bookshelf, 'is_public', false);
    const bookshelfOwner = get(bookshelfDetail, 'userId', null);
    const userId = get(user, 'id', null);
    const bookshelfIsOwnedByUser = user && parseInt(userId) === parseInt(bookshelfOwner);

    if (bookshelf && (!user && !isPublicBookshelf)) {
      return <Redirect to={URLS.dashboard} />;
    }

    const bookshelfName = bookshelf ? bookshelf.name : null;
    const bookshelfDescription = bookshelf ? bookshelf.description : null;
    const bookshelfBookCount = bookshelf ? bookshelf.book_count : null;
    const bookshelfPicture = bookshelf ? bookshelf.image : null;
    const isPublic = bookshelf ? bookshelf.is_public : null;
    const authoredBy = bookshelf ? bookshelf.authored_by : null;
    const searchString = get(this, 'props.location.search', null);
    const searchStringExists = searchString.length > 0 && searchString !== '?';
    const bookshelfId = get(bookshelf, 'id', '');
    const editBookshelveLink = `/profile/${this.props.match.params.userId}/editbookshelf/${bookshelfId}/`;

    let cuttedBookshelfName = this.cropString(bookshelfName, MAXIMUM_NUMBER_CHARACHTERS);

    return (
      <React.Fragment>
        {openDeleteDialog && this.deleteConfirmDialog()}
        <div className="section">
          {(user && bookshelfIsOwnedByUser) && (
            <BreadCrumbs links={[
              { text: 'Мои книги', url: `/profile/${this.props.match.params.userId}/` },
              { text: 'Мои полки', url: `/profile/${this.props.match.params.userId}/bookshelves/` },
              { text: cuttedBookshelfName, url: get(this, 'props.location', '') },
            ]} />
          )}
        </div>
        <div className={booksetStyles.mainPicture}>
          {bookshelfPicture
            ? (
              <AdaptiveImage
                className={booksetStyles.image}
                src={{
                  url: bookshelfPicture,
                  width: '500',
                  height: '322',
                }}
                srcSet={{
                  url: bookshelfPicture,
                  width: '768',
                  height: '322',
                }}
                media="min-width: 500px"
                alt={bookshelfName} />
            )
            : <div className={styles.defaultBackground} />
          }
          {authoredBy && (
            <div className={booksetStyles.booksetAuthor}>
              <BooksetAuthor {...authoredBy} />
            </div>
          )}
        </div>
        <div className="section">
          <div className={headerStyles.header}>
            {bookshelfName
              ? <div className={classNames(styles.bookshelfName, 'title-1')}>{bookshelfName}</div>
              : <div className={headerStyles.headerEmpty} />
            }
            <div className={styles.bookshelfInfo}>
              {bookshelfBookCount > 0 && (
                <div className={headerStyles.bookCount}>
                  <div className={headerStyles.bookCountAmount}>
                    {bookshelfBookCount} {pluralize(bookshelfBookCount, 'книга', 'книги', 'книг')}
                  </div>
                  <div className={styles.circle} />
                </div>
              )}
              {isPublic
                ? <div>Видна всем</div>
                : <div>Скрыта</div>
              }
            </div>
          </div>
          {(user && bookshelfIsOwnedByUser) && (
            <div className={styles.dropDownMenu}>
              <DropDownMenu type="edit" extraClassNameDropMenu={styles.menu}>
                <Link to={editBookshelveLink}
                  className={classNames(styles.editLink, 'jest-link-to-edit-bookshelf')}>
                  <div className={styles.editLinkText}>
                    Редактировать
                  </div>
                </Link>
                <span onClick={() => this.handleOpenDeleteDialog()}
                  className={classNames(styles.deleteBookchelf, 'jest-delete-bookshelf')}>
                  <div className={styles.deleteBookchelfText}>
                    Удалить
                  </div>
                </span>
              </DropDownMenu>
            </div>
          )}
          {bookshelfDescription && (
            <CatalogDescription description={bookshelfDescription} />
          )}
          {books && (
            <CatalogFilter
              isOrderEnabled={false}
              subscriptionId={subscriptionId}
              bookType={bookType}
              isResultEmpty={books && books.length === 0 && searchStringExists}
              onChangeSubscription={(value) => this.filterBySubscriptionType(value)}
              onChangeBookType={((value) => this.changeBookType(value))}
              onResetFilter={()=> this.resetFilters()} />
          )}
          {books === null && (
            [...Array(5)].map((item, key) => (
              <EmptyBookCard key={key} />
            ))
          )}
          {books && books.length > 0 && this.getBookList({ books, bookshelfId, user, bookshelfIsOwnedByUser })}

          {books && books.length === 0 && (
            <React.Fragment>
              {searchStringExists
                ? <EmptyFilterResult />
                : (
                  <div className={styles.emptyContent}>
                    <div>
                      Добавьте на полку любую <br />
                      интересную вам книгу со <br />
                      страницы книги
                    </div>
                  </div>
                )
              }
            </React.Fragment>
          )}


          {lastPageNumber > 1 && (
            <ContextPagination
              onPageChange={(newPageNumber) => this.changePage(newPageNumber)}
              currentPage={pageNumber}
              lastPage={lastPageNumber} />
          )}
        </div>
      </React.Fragment>
    );
  }
}

BookshelfDetailView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      bookshelfId: PropTypes.string.isRequired,
    }),
  }),
};

function mapStateToProps(state) {
  return {
    bookshelfDetail: state.bookshelfDetail,
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    BookshelfDetailActions: bindActionCreators(BookshelfDetailActions, dispatch),
    NotificationActions: bindActionCreators(NotificationActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookshelfDetailView);
